import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/svetainiu-kurimas/page.tsx");
